import { BabaBundle } from 'templates/Bundles/Baba';
import { BagelcodeBundle } from 'templates/Bundles/Bagelcode';
import { Bagelcode2Bundle } from 'templates/Bundles/Bagelcode_2';
import { BingoPopBundle } from 'templates/Bundles/BingoPop';
import { CandivoreBundle } from 'templates/Bundles/Candivore';
import { Candivore2Bundle } from 'templates/Bundles/Candivore_2';
import { CashmanCasinoBundle } from 'templates/Bundles/CashmanCasino';
import { ClassicBundle } from 'templates/Bundles/Classic/Bundle';
import { CommunixBundle } from 'templates/Bundles/Communix';
import { GhostBundle } from 'templates/Bundles/GhostStudio';
import { HeartOfVegasBundle } from 'templates/Bundles/HeartOfVegas';
import { MainSubBundle } from 'templates/Bundles/HugeCasino/Bundle';
import { LightningLinkBundle } from 'templates/Bundles/LightningLinkCasino';
import { LocoBingoBundle } from 'templates/Bundles/LocoBingo';
import { Me2onBundle } from 'templates/Bundles/Me2on';
import { MightyFuBundle } from 'templates/Bundles/MightyFuCasino';
import { PipaBundle } from 'templates/Bundles/Pipa';
import { PlaySimpleBundle } from 'templates/Bundles/PlaySimple';
import { PlaydogBundle } from 'templates/Bundles/Playdog';
import { JackpotSlotsBundle } from 'templates/Bundles/ProductMadness';
import { WhispersBundle } from 'templates/Bundles/Whispers';
import { BabaSpecialOffer } from 'templates/SpecialOffer/Baba';
import { BagelCodeSpecialOffer } from 'templates/SpecialOffer/BagelCode';
import { BingoPopSpecialOffer } from 'templates/SpecialOffer/BingoPop';
import { GhostSpecialOffer } from 'templates/SpecialOffer/GhostStudio';
import { HugeSpecialOffer } from 'templates/SpecialOffer/HugeCasino';
import { LocoBingoSpecialOffer } from 'templates/SpecialOffer/LocoBingo';
import { MatchMastersSpecialOffer } from 'templates/SpecialOffer/MatchMasters';
import { Me2onSpecialOffer } from 'templates/SpecialOffer/Me2on';
import { PipaSpecialOffer } from 'templates/SpecialOffer/Pipa';
import { PlaySimpleSpecialOffer } from 'templates/SpecialOffer/PlaySimple';
import { PokerFaceSpecialOffer } from 'templates/SpecialOffer/PokerFace';
import { ProductMadnessSpecialOffer } from 'templates/SpecialOffer/ProductMadness';
import { SpecialOfferProps } from 'templates/SpecialOffer/types';
import {
  EBundlesInternalViewModel,
  EConfigs,
  ESpecialOfferInternalViewModel,
} from 'utils/enums';
import {
  BundleProps,
  OfferData,
  OfferDataForPublisherEventV2,
} from 'utils/types';
import { LightningLinkPlayerLevel } from 'templates/PlayerLevel/LightningLink';
import { EvergreenDynamicBundle } from 'templates/Bundles/EvergreenDynamic';
import { Communix2Bundle } from 'templates/Bundles/Communix_2';
import { HeartOfVegasMapPlayerLevel } from 'templates/PlayerLevel/HeartOfVegas/player-level-map';
import { CashmanCasinoPlayerLevel } from 'templates/PlayerLevel/CashmanCasino';
import { DynamicHeartOfVegasBundle } from 'templates/Bundles/PM_Dynamic/HOV';
import { DynamicLightningLinkBundle } from 'templates/Bundles/PM_Dynamic/LLC';
import { FabelTownBundle } from 'templates/Bundles/FabelTown';
import { FabelTownSpecialOffer } from 'templates/SpecialOffer/FabelTown';
import { DecaBundle } from 'templates/Bundles/Deca';
import { DecaSpecialOffer } from 'templates/SpecialOffer/Deca';
import { DynamicMightyFuCasinoBundle } from 'templates/Bundles/PM_Dynamic/MFC';
import { DynamicCashManCasinoBundle } from 'templates/Bundles/PM_Dynamic/CMC';
import { LoadCompleteBundle } from 'templates/Bundles/LoadComplete';
import { LoadCompleteSpecialOffer } from 'templates/SpecialOffer/LoadComplete';
import { SpinXBundle } from 'templates/Bundles/SpinX';
import { SpinXSpecialOffer } from 'templates/SpecialOffer/SpinX';
import { CashFrenzyBundle } from 'templates/Bundles/CashFrenzy';
import { CashFrenzySpecialOffer } from 'templates/SpecialOffer/CashFrenzy';
import { GennmuSpecialOffer } from 'templates/SpecialOffer/Gennmu';
import { JunesJourneyDailyBonus } from 'templates/DailyBonus/JunesJourney';
import { BanditosSpecialOffer } from 'templates/SpecialOffer/Banditos';
import { BanditosBundle } from 'templates/Bundles/Banditos';
import { BanditosDailyBonus } from 'templates/DailyBonus/Banditos';
import { JunesJourneyDailyBonusBadge } from 'templates/DailyBonusBadge/JunesJourney';
import { SpinxDailyBonus } from 'templates/DailyBonus/Spinx';
import { CashFrenzyDailyBonus } from 'templates/DailyBonus/CashFrenzy';

const mapConfigs: Record<
  EConfigs,
  Partial<Record<EBundlesInternalViewModel, any>>
> = {
  // BUNDLE
  [EConfigs.desktopMaxWidth]: {
    [EBundlesInternalViewModel.JACKPOT_SLOTS]: '400px',
    [EBundlesInternalViewModel.MAIN_SUB]: '400px',
    [EBundlesInternalViewModel.BIG_FISH_CASINO]: '400px',
    [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO]: '400px',
    [EBundlesInternalViewModel.MIGHTY_FU_CASINO]: '400px',
    [EBundlesInternalViewModel.HEART_OF_VEGAS]: '400px',
    [EBundlesInternalViewModel.PIPA]: '528px',
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '400px',
    [EBundlesInternalViewModel.BINGO_POP]: '400px',
    [EBundlesInternalViewModel.SPIN_X]: '480px',
    [EBundlesInternalViewModel.CASH_FRENZY]: '428px',
    [EBundlesInternalViewModel.LOAD_COMPLETE]: '478px',
    [EBundlesInternalViewModel.BANDITOS]: '450px',
  },
  [EConfigs.maxWidthOverride]: {
    [EBundlesInternalViewModel.MAIN_SUB]: '400px',
    [EBundlesInternalViewModel.WHISPERS]: '196px',
    [EBundlesInternalViewModel.BABA]: '400px',
    [EBundlesInternalViewModel.SPIN_X]: '480px',
    [EBundlesInternalViewModel.CASH_FRENZY]: '428px',
    [EBundlesInternalViewModel.LOAD_COMPLETE]: '478px',
    [EBundlesInternalViewModel.BANDITOS]: '450px',
  },
  [EConfigs.gapX]: {
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '18px',
    [EBundlesInternalViewModel.WHISPERS]: '17px',
    [EBundlesInternalViewModel.PIPA]: '8px',
  },
  [EConfigs.gapY]: {
    [EBundlesInternalViewModel.BAGELCODE]: '8px',
    [EBundlesInternalViewModel.BAGELCODE2]: '8px',
    [EBundlesInternalViewModel.PIPA]: '8px',
  },
  [EConfigs.marginTop]: {
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '0px',
    [EBundlesInternalViewModel.WHISPERS]: '25px',
  },
  // BANNER
  [EConfigs.bannerMaxWidth]: {
    [EBundlesInternalViewModel.WHISPERS]: '418px',
    [EBundlesInternalViewModel.PIPA]: '528px',
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '322px',
    [EBundlesInternalViewModel.SPIN_X]: '480px',
    [EBundlesInternalViewModel.CASH_FRENZY]: '428px',
    [EBundlesInternalViewModel.DECA]: '703px',
    [EBundlesInternalViewModel.LOAD_COMPLETE]: '478px',
    [EBundlesInternalViewModel.BANDITOS]: '450px',
  },
  [EConfigs.bannerMinWidth]: {
    [EBundlesInternalViewModel.WHISPERS]: '343px',
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '224px',
    [EBundlesInternalViewModel.SPIN_X]: '343px',
    [EBundlesInternalViewModel.CASH_FRENZY]: '343px',
    [EBundlesInternalViewModel.DECA]: '343px',
    [EBundlesInternalViewModel.LOAD_COMPLETE]: '343px',
    [EBundlesInternalViewModel.BANDITOS]: '340px',
  },
  [EConfigs.bannerMX]: {
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '25%',
    [EBundlesInternalViewModel.SPIN_X]: '25%',
    [EBundlesInternalViewModel.CASH_FRENZY]: '25%',
    [EBundlesInternalViewModel.DECA]: '10%',
    [EBundlesInternalViewModel.LOAD_COMPLETE]: '25%',
    [EBundlesInternalViewModel.BANDITOS]: '25%',
  },
  [EConfigs.bannerMB]: {
    [EBundlesInternalViewModel.SPIN_X]: '0px',
    [EBundlesInternalViewModel.CASH_FRENZY]: '0px',
    [EBundlesInternalViewModel.BANDITOS]: '0px',
  },
  // ROLLING OFFER
  [EConfigs.rollingOfferMaxWidth]: {
    [EBundlesInternalViewModel.MAIN_SUB]: '400px',
    [EBundlesInternalViewModel.CANDIVORE]: '400px',
  },
};

const defaultConfigs: Record<EConfigs, any> = {
  // BUNDLE
  [EConfigs.desktopMaxWidth]: '1250px',
  [EConfigs.maxWidthOverride]: '400px',
  [EConfigs.gapX]: '12px',
  [EConfigs.gapY]: undefined,
  [EConfigs.marginTop]: '10px',
  // BANNER
  [EConfigs.bannerMaxWidth]: undefined,
  [EConfigs.bannerMinWidth]: undefined,
  [EConfigs.bannerMX]: undefined,
  [EConfigs.bannerMB]: undefined,
  // ROLLING OFFER
  [EConfigs.rollingOfferMaxWidth]: '1250px',
};

export const getTemplateProperty: any = (
  property: EConfigs,
  viewModel: EBundlesInternalViewModel,
) => mapConfigs[property][viewModel] || defaultConfigs[property];

export const mapBundleViewModel: Record<
  EBundlesInternalViewModel,
  React.FC<BundleProps>
> = {
  [EBundlesInternalViewModel.AK]: ClassicBundle,
  [EBundlesInternalViewModel.COMMUNIX]: CommunixBundle,
  [EBundlesInternalViewModel.COMMUNIX2]: Communix2Bundle,
  [EBundlesInternalViewModel.MATCH]: CandivoreBundle,
  [EBundlesInternalViewModel.CANDIVORE]: Candivore2Bundle,
  [EBundlesInternalViewModel.MAIN_SUB]: MainSubBundle,
  [EBundlesInternalViewModel.BAGELCODE]: BagelcodeBundle,
  [EBundlesInternalViewModel.BAGELCODE2]: Bagelcode2Bundle,
  [EBundlesInternalViewModel.LOCO_BINGO]: LocoBingoBundle,
  [EBundlesInternalViewModel.JACKPOT_SLOTS]: JackpotSlotsBundle,
  [EBundlesInternalViewModel.BIG_FISH_CASINO]: JackpotSlotsBundle,
  [EBundlesInternalViewModel.CASHMAN_CASINO]: CashmanCasinoBundle,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO]: LightningLinkBundle,
  [EBundlesInternalViewModel.EVERGREEN_DYNAMIC]: EvergreenDynamicBundle,
  [EBundlesInternalViewModel.HEART_OF_VEGAS]: HeartOfVegasBundle,
  [EBundlesInternalViewModel.ME2ON]: Me2onBundle,
  [EBundlesInternalViewModel.PLAY_SIMPLE]: PlaySimpleBundle,
  [EBundlesInternalViewModel.PIPA]: PipaBundle,
  [EBundlesInternalViewModel.WHISPERS]: WhispersBundle,
  [EBundlesInternalViewModel.BABA]: BabaBundle,
  [EBundlesInternalViewModel.MIGHTY_FU_CASINO]: MightyFuBundle,
  [EBundlesInternalViewModel.GHOST]: GhostBundle,
  [EBundlesInternalViewModel.BINGO_POP]: BingoPopBundle,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO2]:
    DynamicLightningLinkBundle,
  [EBundlesInternalViewModel.DYNAMIC_HEART_OF_VEGAS]: DynamicHeartOfVegasBundle,
  [EBundlesInternalViewModel.DYNAMIC_MIGHTY_FU_CASINO]:
    DynamicMightyFuCasinoBundle,
  [EBundlesInternalViewModel.FABEL_TOWN]: FabelTownBundle,
  [EBundlesInternalViewModel.DECA]: DecaBundle,
  [EBundlesInternalViewModel.LOAD_COMPLETE]: LoadCompleteBundle,
  [EBundlesInternalViewModel.DYNAMIC_CASH_MAN_CASINO]:
    DynamicCashManCasinoBundle,
  [EBundlesInternalViewModel.PLAYDOG]: PlaydogBundle,
  [EBundlesInternalViewModel.SPIN_X]: SpinXBundle,
  [EBundlesInternalViewModel.CASH_FRENZY]: CashFrenzyBundle,
  [EBundlesInternalViewModel.JUNES_JOURNEY]: CashFrenzyBundle, // todo
  [EBundlesInternalViewModel.BANDITOS]: BanditosBundle,
};

export const mapSpecialOfferViewModel: Record<
  ESpecialOfferInternalViewModel,
  React.FC<SpecialOfferProps>
> = {
  [ESpecialOfferInternalViewModel.HUGE]: HugeSpecialOffer,
  [ESpecialOfferInternalViewModel.MATCH_MASTERS]: MatchMastersSpecialOffer,
  [ESpecialOfferInternalViewModel.POKER_FACE]: PokerFaceSpecialOffer,
  [ESpecialOfferInternalViewModel.BAGELCODE]: BagelCodeSpecialOffer,
  [ESpecialOfferInternalViewModel.LOCO_BINGO]: LocoBingoSpecialOffer,
  [ESpecialOfferInternalViewModel.ME2ON]: Me2onSpecialOffer,
  [ESpecialOfferInternalViewModel.PIPA]: PipaSpecialOffer,
  [ESpecialOfferInternalViewModel.JACKPOT_SLOTS]: ProductMadnessSpecialOffer,
  [ESpecialOfferInternalViewModel.BIG_FISH_CASINO]: ProductMadnessSpecialOffer,
  [ESpecialOfferInternalViewModel.BABA]: BabaSpecialOffer,
  [ESpecialOfferInternalViewModel.PLAY_SIMPLE]: PlaySimpleSpecialOffer,
  [ESpecialOfferInternalViewModel.GHOST]: GhostSpecialOffer,
  [ESpecialOfferInternalViewModel.BINGO_POP]: BingoPopSpecialOffer,
  [ESpecialOfferInternalViewModel.FABEL_TOWN]: FabelTownSpecialOffer,
  [ESpecialOfferInternalViewModel.DECA]: DecaSpecialOffer,
  [ESpecialOfferInternalViewModel.LOAD_COMPLETE]: LoadCompleteSpecialOffer,
  [ESpecialOfferInternalViewModel.SPIN_X]: SpinXSpecialOffer,
  [ESpecialOfferInternalViewModel.CASH_FRENZY]: CashFrenzySpecialOffer,
  [ESpecialOfferInternalViewModel.GENNMU]: GennmuSpecialOffer,
  [ESpecialOfferInternalViewModel.BANDITOS]: BanditosSpecialOffer,
};

export const mapPlayerLevelViewModel: Partial<
  Record<EBundlesInternalViewModel | string, any>
> = {
  [EBundlesInternalViewModel.HEART_OF_VEGAS]: HeartOfVegasMapPlayerLevel,
  [EBundlesInternalViewModel.DYNAMIC_HEART_OF_VEGAS]:
    HeartOfVegasMapPlayerLevel,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO]: LightningLinkPlayerLevel,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO2]: LightningLinkPlayerLevel,
  [EBundlesInternalViewModel.CASHMAN_CASINO]: CashmanCasinoPlayerLevel,
  [EBundlesInternalViewModel.DYNAMIC_CASH_MAN_CASINO]: CashmanCasinoPlayerLevel,
};

export const mapDailyBonusViewModel: Partial<
  Record<EBundlesInternalViewModel | string, any>
> = {
  [EBundlesInternalViewModel.JUNES_JOURNEY]: JunesJourneyDailyBonus,
  [EBundlesInternalViewModel.BANDITOS]: BanditosDailyBonus,
  [EBundlesInternalViewModel.SPIN_X]: SpinxDailyBonus,
  [EBundlesInternalViewModel.CASH_FRENZY]: CashFrenzyDailyBonus,
};

export const mapDailyBonusBadgeViewModel: Partial<
  Record<EBundlesInternalViewModel | string, any>
> = {
  [EBundlesInternalViewModel.JUNES_JOURNEY]: JunesJourneyDailyBonusBadge,
};

export interface OrderPopupEvents {
  onOrderFail: () => void;
  onOrderSuccess: () => void;
}

export const extractOfferMainDetailsV2 = (
  offers: OfferData[],
): OfferDataForPublisherEventV2[] => {
  return offers.map((offer: OfferData) => ({
    id: offer.offerId,
    name: offer.offerName,
    publisherOfferId: offer.publisherOfferId || offer.offerId,
    type: offer.offerType,
    index: offer.indexToCollect,
    pricePoint:
      offer.productsSequence[
        offer.indexToCollect ? offer.indexToCollect - 1 : 0
      ]?.prices?.priceInUsdCents / 100,
    subType: offer.subType,
    offerJwt: offer.offerJwt,
    products: offer.productsSequence[
      offer.indexToCollect ? offer.indexToCollect - 1 : 0
    ].products.map((product) => ({
      publisherProductId: product.publisherProductId,
      amount: product.quantity,
    })),
  }));
};
